import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Container, Row, Col, Form, Button, Card, Modal, Popover, Overlay, Nav, Spinner } from 'react-bootstrap';
import { useOutletContext, useNavigate, useLocation } from 'react-router-dom';
import spinnerIcon from './/./../assets/img/loadingSpinner.gif'
import PaginationComponent from '../components/pagination/PaginationComponent.js'
import { useAuth0 } from "@auth0/auth0-react";
import { apiGet, apiPut } from "../services/AuthService.js";
import { useSessionState } from "../lib/useSessionState.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { useMembershipSubscriptionStatus, PLAN_ID } from '../components/membership/MembershipPlans-SubscriptionStatus.js'
import {
    btnGold, btnGoldHover, FOCUS_GOLD, COLORS,
    header, footer, goldLinkBase, addUnderline, removeUnderline,
    boxshadowHover, boxshadowUnHover,
    showAdvancedBtn, searchBtn, uploadBtn, resetFiltersBtn, sourceDataBtn,
    statusColors, darkStatusColors,
    formLabel, columnTitle, columnSortLink, goldInputFocus, statusLabel,
    frame, goldFaPlus, faIconStyle,
    inputSm, paginationStyle, activePaginationStyle,
    dropDownToggle, dropDownInput, dropDownMenu, tableRowHover, tableRowUnHover, stickyThStyle,
    filterActiveIndicator,
} from '../styles/goldTheme.js'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { faFilter } from '@fortawesome/free-solid-svg-icons'

// Phase I light-mode palette (was DK / dark-mode). Kept as `DK` to avoid a mass rename of JSX.
// Card.Header is charcoal per the style doc; everything else moves to white with dark text.
const DK = {
    header:    { backgroundColor: '#333333', color: '#f1f1f1', padding: '8px 16px' },
    footer:    { backgroundColor: '#f9fafb', color: '#1f2937', padding: '12px 16px' },
    stickyTh:  { position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#333333', color: '#C8B568', fontSize: 13, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.04em' },
    adminTh:   { position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#333333', color: '#C8B568', fontSize: 13, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.04em', borderRight: '1px solid #4a4a4a' },
    input:     { backgroundColor: '#ffffff', color: '#1f2937', borderColor: '#d1d5db', fontSize: '12px' },
    ddToggle:  { fontSize: '12px', width: '100%', textAlign: 'left', padding: '4px 17px 4px 4px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', backgroundColor: '#ffffff', color: '#1f2937', borderColor: '#d1d5db' },
    ddMenu:    { maxHeight: 200, overflowY: 'auto', backgroundColor: '#ffffff', '--bs-dropdown-bg': '#ffffff', '--bs-dropdown-link-color': '#1f2937', '--bs-dropdown-link-hover-bg': 'rgba(37, 99, 235, 0.08)', '--bs-dropdown-link-hover-color': '#2563EB', '--bs-dropdown-link-active-bg': '#2563EB', '--bs-dropdown-link-active-color': '#ffffff' },
    rowOdd:    { fontSize: '.9rem', fontWeight: '500', color: '#1f2937', backgroundColor: '#ffffff' },
    rowEven:   { fontSize: '.9rem', fontWeight: '500', color: '#1f2937', backgroundColor: '#f9fafb' },
    rowHover:  { borderTop: '2px solid #2563EB', borderBottom: '2px solid #2563EB', backgroundColor: 'rgba(37, 99, 235, 0.08)' },
    rowUnhov:  { border: 'none', borderBottom: '1px solid #e5e7eb' },
};

function CdexSenderCodeModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h4>CDEX Sender Code - {props.selectedOperator.operatorName}</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>CDEX Sender Code is needed for CDEX file creation.  Do you wish to add it now?</h6>
                <Form.Group className="mb-3" controlId="cdexSenderCode">
                    <Form.Label>Cdex Sender Code</Form.Label>
                    <Form.Control name="cdexSenderCode" size="sm" aria-label="Cdex Sender Code" value={props.selectedOperator.cdexSenderCode} style={{ width: '100' }} onChange={e => props.setSelectedOperator({ ...props.selectedOperator, cdexSenderCode: e.currentTarget.value.substring(0, 2) })} />
                </Form.Group>
                <Button
                    type='button'
                    size='sm'
                    style={{ marginTop: '20px', width: '100px' }}
                    disabled={false}
                    onClick={() => props.updateCdexSenderCode(props.selectedOperator.operatorId, props.selectedOperator.cdexSenderCode)}
                >
                    Save
                </Button>
                <Button
                    type='button'
                    size='sm'
                    style={{ marginTop: '20px', marginLeft: '20px', width: '100px' }}
                    disabled={false}
                    onClick={props.onHide}
                >
                    Cancel
                </Button>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

function MembershipModal(props) {
    const messageLines = Array.isArray(props.messageLines) && props.messageLines.length > 0
        ? props.messageLines
        : [
            'Unlimited Excel & CDEX Conversion for all your operators data.',
            'Upgrade to Blackgold - Revenue or Oil Baron to access!'
        ];

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Body
                style={{
                    backgroundColor: '#ffffff',
                    color: '#1f2937',
                    border: '1px solid #e5e7eb',
                    borderRadius: '18px',
                    padding: '18px 18px 20px 18px',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.18)'
                }}
            >
                <Container>
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'right' }}>
                            <FontAwesomeIcon
                                icon={faXmark}
                                style={{ cursor: 'pointer', padding: '5px', width: '25px', height: '25px', color: '#6b7280' }}
                                onClick={props.onHide}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center">
                            <div style={{ color: '#1f2937', fontSize: '1rem', fontWeight: '700', textAlign: 'center', lineHeight: '1.45' }}>
                                {messageLines.map((line, index) => (
                                    <div key={index}>{line}</div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center">
                            <Button
                                size="lg"
                                onClick={props.onMemberButtonClick}
                                style={{
                                    width: '240px',
                                    border: '1px solid #C8B568',
                                    borderRadius: '20px',
                                    backgroundColor: '#C8B568',
                                    color: '#000',
                                    fontSize: '1rem',
                                    fontWeight: '700',
                                    padding: '6px 12px',
                                    marginTop: '18px',
                                    marginBottom: '4px'
                                }}
                            >
                                See Plans
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
        </Modal>
    );
}

//Popover stays open while the mouse is over the button or the popover, and closes as soon as it leaves both
function HoverPopoverTrigger({ popoverId, openPopoverId, setOpenPopoverId, overlay, showDelay = 0, children }) {
    const targetRef = useRef(null);
    const showTimerRef = useRef(null);

    useEffect(() => () => clearTimeout(showTimerRef.current), []);

    const isOverTriggerOrPopover = (node) =>
        node instanceof Element && (targetRef.current?.contains(node) || node.closest('.popover') !== null);

    const handleMouseEnter = () => {
        clearTimeout(showTimerRef.current);
        showTimerRef.current = setTimeout(() => setOpenPopoverId(popoverId), showDelay);
    };

    const handleMouseLeave = (e) => {
        clearTimeout(showTimerRef.current);
        if (isOverTriggerOrPopover(e.relatedTarget)) return;
        setOpenPopoverId(current => (current === popoverId ? null : current));
    };

    return (
        <>
            <span ref={targetRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ display: 'inline-block' }}>
                {children}
            </span>
            <Overlay target={targetRef} show={openPopoverId === popoverId} placement="top" transition={false}>
                {React.cloneElement(overlay, { onMouseLeave: handleMouseLeave })}
            </Overlay>
        </>
    );
}

const CheckFiles = props => {

    //properties
    const baseUrl = process.env.REACT_APP_API_BASEURL;
    const { getAccessTokenSilently } = useAuth0();

    //stateful properties (hooks)
    const navigate = useNavigate();
    const [currentAccount, accountProfile, setAccountProfile, toggleIsShowSidebarMd, setIsShowSidebarMd] = useOutletContext();
    const [pageStatus, setPageStatus] = useState('ready');
    const [dataStatus, setDataStatus] = useState('');
    const [pageErrors, setPageErrors] = useState('');
    const [dataErrors, setDataErrors] = useState('');
    const [displayResultGrid, setDisplayResultGrid] = useState(true);
    const [owners, setOwners] = useState([]);
    const [operators, setOperators] = useState([]);
    const [fileTypes, setFileTypes] = useState(['Select File Type...', 'Revenue', 'JIB', 'Plant', '1099']);
    const [selectedOperator, setSelectedOperator] = useState([]);
    const [checkStatements, setCheckStatements] = useState([]);
    const [years, setYears] = useState([]);
    const [months, setMonths] = useState([]);
    const [statusItems, setStatusItems] = useState(['', 'Released', 'Downloaded']);
    const [hydrated, setHydrated] = useState(false);
    const [searchVersion, setSearchVersion] = useState(0);
    const location = useLocation();

    //Filter state persisted to sessionStorage so navigating away and back
    //restores the user's filters. skipCount is reset to 0 on restore (page
    //starts back at 1, but the filter values come back). The key is scoped by
    //currentAccount.id so each account has its own slot — switching accounts
    //(either via the admin switcher or by logging in as a different user) no
    //longer leaks the previous account's filters into the next one.
    const resetSkipCount = (loaded) => ({ ...loaded, skipCount: 0 });
    const acctKey = currentAccount?.id ?? 'none';
    const [dataCriteria, setDataCriteria] = useSessionState(`CheckFiles.dataCriteria.${acctKey}`, {
        skipCount: 0,
        takeCount: 50,
        operatorId: 0,
        ownerId: 0,
        ownerName: '',
        ownerNumber: '',
        checkNumber: '',
        checkAmount: '',
        fromMonth: '',
        fromYear: '',
        toMonth: '',
        toYear: '',
        statusId: 0
    }, resetSkipCount);

    const [jibDataCriteria, setJibDataCriteria] = useSessionState(`CheckFiles.jibDataCriteria.${acctKey}`, {
        skipCount: 0,
        takeCount: 50,
        operatorId: 0,
        ownerId: 0,
        ownerName: '',
        ownerNumber: '',
        invoiceNumber: '',
        invoiceAmount: '',
        membershipStatus: '',
        fromMonth: '',
        fromYear: '',
        toMonth: '',
        toYear: '',
        statusId: 0
    }, resetSkipCount);

    const [ten99DataCriteria, setTen99DataCriteria] = useSessionState(`CheckFiles.ten99DataCriteria.${acctKey}`, {
        skipCount: 0,
        takeCount: 50,
        operatorId: 0,
        ownerId: 0,
        ownerName: '',
        ownerNumber: '',
        membershipStatus: '',
        fromYear: '',
        toYear: '',
        statusId: 0
    }, resetSkipCount);

    const CRITERIA_BY_TYPE = {
        '1': dataCriteria,   // Revenue
        '2': jibDataCriteria,    // JIB
        '4': ten99DataCriteria    // 1099
    };

    const SETTER_BY_TYPE = {
        '1': setDataCriteria,
        '2': setJibDataCriteria,
        '4': setTen99DataCriteria
    };

    const [fileTypeCriteria, setFileTypeCriteria] = useSessionState(`CheckFiles.fileTypeCriteria.${acctKey}`, { fileTypeId: '1' });

    const activeCriteria = CRITERIA_BY_TYPE[fileTypeCriteria.fileTypeId] || dataCriteria;

    const [rowCount, setRowCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [screenHeight, setScreenHeight] = useState(100);
    const [tableHeight, setTableHeight] = useState(300);
    const cardRef = useRef(null);
    const cardBodyRef = useRef(null);

    const [modalShow, setModalShow] = useState(false);
    const [memberModalShow, setMemberModalShow] = useState(false);

    const [hoveredBtn, setHoveredBtn] = useState(null);
    const [openPopoverId, setOpenPopoverId] = useState(null);

    const isJibEnabled = (baseUrl && (baseUrl.includes("local") || baseUrl.includes("dev") || baseUrl.includes("qa") || baseUrl.includes("totdata-api.azurewebsites.net")));
    const is1099Enabled = (baseUrl && (baseUrl.includes("local") || baseUrl.includes("dev") || baseUrl.includes("qa") || baseUrl.includes("totdata-api.azurewebsites.net")));
    const isNonProd = baseUrl && !baseUrl.includes("totdata-api.azurewebsites");
    const hasOwnerRelations = checkStatement => isNonProd && /hilcorp/i.test(checkStatement.operatorName ?? '');

    const membershipAccountProfile = useMemo(() => ({
        ...(currentAccount ?? {}),
        ...(accountProfile ?? {}),
    }), [currentAccount, accountProfile]);

    const {
        subscriptionsLoadFailed,
        subscriptionsError,
        effectivePlanId,
    } = useMembershipSubscriptionStatus({
        currentAccount,
        accountProfile: membershipAccountProfile,
        getAccessTokenSilently,
        includeCancelable: false,
        legacySubscriptionStatusId:
            membershipAccountProfile?.subscriptionStatusId ??
            membershipAccountProfile?.SubscriptionStatusId ??
            0,
        legacyPlanId:
            membershipAccountProfile?.planId ??
            membershipAccountProfile?.PlanId ??
            membershipAccountProfile?.membershipPlanId ??
            membershipAccountProfile?.MembershipPlanId ??
            '',
        baseUrl
    });

    const canCreateRevenueFilesManaged = [PLAN_ID.blackgoldRevenue, PLAN_ID.oilBaron, PLAN_ID.bigRig].includes(effectivePlanId);
    const canCreateJibFilesManaged = [PLAN_ID.blackgoldJib, PLAN_ID.oilBaron, PLAN_ID.bigRig].includes(effectivePlanId);

    const canCreateRevenueFiles = canCreateRevenueFilesManaged;
    const canCreateJibFiles = canCreateJibFilesManaged;
    const hasImpersonate = Boolean(accountProfile?.hasImpersonate);

    useEffect(() => {
        if (!subscriptionsLoadFailed) return;
        setPageStatus('error');
        setPageErrors(subscriptionsError || 'Failed to load membership subscription status.');
    }, [subscriptionsLoadFailed, subscriptionsError]);

    const lockedMembershipButtonStyle = {
        width: '225px',
        border: '1px solid #C8B568',
        borderRadius: '20px',
        backgroundColor: '#C8B568',
        color: '#000',
        fontSize: '.8rem',
        fontWeight: '700',
        padding: '6px 10px',
        marginTop: '6px'
    };

    //Covers the gap between the button and the popover so moving up into the popover doesn't close it
    const popoverHoverBridge = { position: 'absolute', left: 0, right: 0, top: '100%', height: '8px' };

    const createLockedMembershipPopover = (messageLines, popoverId) => (
        <Popover
            id={popoverId}
            style={{
                maxWidth: '360px',
                border: '1px solid #e5e7eb',
                backgroundColor: '#ffffff',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.18)',
                '--bs-popover-bg': '#ffffff',
                '--bs-popover-border-color': '#e5e7eb',
                '--bs-popover-header-bg': '#333333',
                '--bs-popover-header-color': '#f1f1f1',
                '--bs-popover-body-color': '#1f2937'
            }}
        >
            <Popover.Header
                as="h3"
                style={{
                    backgroundColor: '#333333',
                    color: '#f1f1f1',
                    borderBottom: 'none',
                    textAlign: 'center',
                    fontWeight: '700'
                }}
            >
                Membership
            </Popover.Header>
            <Popover.Body
                style={{
                    backgroundColor: '#ffffff',
                    color: '#1f2937',
                    padding: '14px'
                }}
            >
                <Container>
                    <Row style={{ fontSize: '.8rem', color: '#1f2937', fontWeight: '700', marginTop: '-4px', textAlign: 'center', lineHeight: '1.45' }}>
                        <Col>
                            {messageLines.map((line, index) => (
                                <div key={index}>{line}</div>
                            ))}
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center" style={{ marginTop: '12px' }} >
                        <Button
                            size="sm"
                            onClick={() => navigate('/membership-plans')}
                            style={lockedMembershipButtonStyle}
                        >
                            See Plans
                        </Button>
                    </Row>
                </Container>
            </Popover.Body>
            <div style={popoverHoverBridge} />
        </Popover>
    );

    const popoverRevenueMembership = createLockedMembershipPopover(
        [
            'Unlimited Excel & CDEX Conversion for all your operators data.',
            'Upgrade to Blackgold - Revenue or Oil Baron to access!'
        ],
        'popover-membership-revenue'
    );

    const popoverJibMembership = createLockedMembershipPopover(
        [
            'Unlimited Excel Conversion for all your operators data.',
            'Upgrade to Blackgold - JIB or Oil Baron to access!'
        ],
        'popover-membership-jib'
    );

    const popoverNoFee = (
        <Popover id="popover-basic">
            <Popover.Header as="h3">Membership</Popover.Header>
            <Popover.Body>
                <Container>
                    <Row style={{ fontSize: '.8rem', fontWeight: '700', marginTop: '-12px' }}>
                        This download is included in your current membership plan.  No fee to download.
                    </Row>
                </Container>
            </Popover.Body>
            <div style={popoverHoverBridge} />
        </Popover>
    );

    //initialize page
    useEffect(() => {
        (async () => {
            //console.log('Initializing page...');

            if (setIsShowSidebarMd)
                setIsShowSidebarMd(true);

            //get inner browser window height
            const height = window.innerHeight;
            setScreenHeight(height);

            {
                const displayTrialModal = localStorage.getItem('displayTrialModal');
                if ((displayTrialModal ?? '') === 'true') {
                    //don't show membership modal popup; keeping code though in case we need it again later
                    //setMemberModalShow(true);
                } else {
                    setMemberModalShow(false);
                }
                localStorage.setItem('displayTrialModal', 'false');

                try {
                    const response = await initializeForm();
                    setOperators(response.operators);
                    setOwners(response.owners);
                    setYears(response.dates.years);
                    setMonths(response.dates.months);

                    //Use the previous (possibly sessionStorage-restored) value when
                    //it's non-default; otherwise fall back to the API defaults so
                    //first-time visitors still see something sensible.
                    setDataCriteria(prev => ({
                        ...prev,
                        operatorId: prev.operatorId || response.operators[0].id,
                        //ownerId: response.owners[0] === null ? 0 : response.owners[0].id,
                        fromMonth: prev.fromMonth || response.dates.fromMonth,
                        fromYear: prev.fromYear || response.dates.fromYear,
                        toMonth: prev.toMonth || response.dates.currMonth,
                        toYear: prev.toYear || response.dates.currYear,
                        takeCount: prev.takeCount || 50,
                        skipCount: 0,
                    }));

                    setJibDataCriteria(prev => ({
                        ...prev,
                        operatorId: prev.operatorId || response.operators[0].id,
                        fromMonth: prev.fromMonth || response.dates.fromMonth,
                        fromYear: prev.fromYear || response.dates.fromYear,
                        toMonth: prev.toMonth || response.dates.currMonth,
                        toYear: prev.toYear || response.dates.currYear,
                        takeCount: prev.takeCount || 50,
                        skipCount: 0
                    }));

                    setTen99DataCriteria(prev => ({
                        ...prev,
                        operatorId: prev.operatorId || response.operators[0].id,
                        fromYear: prev.fromYear || response.dates.fromYear,
                        toYear: prev.toYear || response.dates.currYear,
                        takeCount: prev.takeCount || 50,
                        skipCount: 0
                    }));

                    const sessionDataStr = localStorage.getItem('checkFileState');
                    if (location.state?.fileTypeId) {
                        setFileTypeCriteria({ fileTypeId: String(location.state.fileTypeId) });
                    } else if (sessionDataStr) {
                        try {
                            const s = JSON.parse(sessionDataStr);

                            if (s.fileTypeId) {
                                setFileTypeCriteria({ fileTypeId: String(s.fileTypeId) });
                            }
                        } catch (e) {
                            console.warn('Bad checkFileState in localStorage:', e);
                        }
                    }

                    setHydrated(true);
                    setPageStatus('ready');
                } catch (ex) {
                    setPageStatus('error');
                    setPageErrors(ex.message);
                }
            }
        })();
    }, [location.state]);

    //window resize handler
    useEffect(() => {
        const handleResize = () => setScreenHeight(window.innerHeight);

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    //size the table so the card and page footer end at the bottom of the window
    useEffect(() => {
        const card = cardRef.current;
        const cardBody = cardBodyRef.current;
        const pageFooter = document.querySelector('footer.footer');
        if (pageStatus !== 'ready' || !card || !cardBody || !pageFooter)
            return;

        const bodyRect = cardBody.getBoundingClientRect();
        const below = card.getBoundingClientRect().bottom - bodyRect.bottom + parseFloat(getComputedStyle(card).marginBottom) + pageFooter.offsetHeight;
        setTableHeight(Math.max(100, Math.floor(document.documentElement.clientHeight - (bodyRect.top + window.scrollY) - below)));
    }, [screenHeight, pageStatus, dataStatus, fileTypeCriteria.fileTypeId]);

    useEffect(() => {
        if (!hydrated) return;

        let cancelled = false;

        const ft = fileTypeCriteria.fileTypeId;
        const criteria = (ft === '2') ? jibDataCriteria : ft === '4' ? ten99DataCriteria : dataCriteria;

        setDataStatus('loading');
        setCheckStatements([]);

        (async () => {
            try {
                const response = await populateCheckStatements({ skipCount: 0 });

                if (cancelled) return;

                if (!response.data || response.data.length === 0) {
                    setRowCount(0);
                    setCheckStatements([]);
                    setDataStatus('nodata');
                } else {
                    setRowCount(response.data[0]?.rowCount || 0);
                    setCheckStatements(response.data);
                    setDataStatus('ready');
                }
            } catch (ex) {
                if (cancelled) return;
                setDataStatus('error');
                setDataErrors(ex.message);
            }
        })();

        return () => {
            cancelled = true;
        }
    }, [fileTypeCriteria.fileTypeId, hydrated, searchVersion]);

    useEffect(() => {
        if (!hydrated) return;

        const payload = {
            fileTypeId: fileTypeCriteria.fileTypeId
        };

        try {
            localStorage.setItem('checkFileState', JSON.stringify(payload));
        } catch (e) {
            console.warn('Failed to save checkFileState:', e);
        }
    }, [fileTypeCriteria.fileTypeId, hydrated]);

    //initialize form
    const initializeForm = async () => {
        //TODO: might just call populateOwners() from useEffect
        //console.log('Initializing form...');

        //get dates for to/from dropdowns
        const dates = await getDates();

        //get operators for dropdown
        const operators = await getOperators();
        const newOperators = [{ id: 0, companyName: '' }, ...operators.data];

        //get owners for dropdown
        const owners = await getOwners();

        return { success: true, operators: newOperators, owners: owners.data, dates: dates };

        //TODO: might want to clean this up with .then /.catch, but how to do with multiple api calls?
        //.then(get other data)
        //.catch(ex => throw...)
    };

    const getDates = () => {

        const currDate = new Date();
        //const day = date.getDate();
        const currMonth = currDate.getMonth() + 1;
        const currYear = currDate.getFullYear();

        //const fromMonth = currMonth === 1 ? 11 : currMonth - 1;   //temp for testing (to list Nov. for 3G LLC)
        //const fromMonth = currMonth === 1 ? 12 : currMonth - 2;
        //const fromYear = currMonth === 1 ? currYear - 1 : currYear;
        const fromMonth = currMonth;
        const fromYear = currYear - 1;

        const years = [currYear - 3, currYear - 2, currYear - 1, currYear, currYear + 1];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        return { months: months, years: years, currMonth: currMonth, currYear: currYear, fromMonth: fromMonth, fromYear: fromYear };
    };
    //
    //get operators (operators this account can receive check statements from - ie. not operators "managed by this account")
    const getOperators = async () => {
        //console.log('Getting Operators...');

        console.log('AccountId: ' + currentAccount.id);

        let apiUrl = 'accounts/' + currentAccount.id + '/checksenders';
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json }
    };

    //get owners (owners managed by this account)
    const getOwners = async () => {
        //console.log('Getting Owners...');

        console.log('AccountId: ' + currentAccount.id);

        const apiUrl = 'accounts/' + currentAccount.id + '/managedreceivers';
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json }
    };

    //fields that auto-trigger a search when changed (text inputs deliberately excluded)
    const AUTO_SEARCH_FIELDS = ['operatorId', 'statusId', 'fromMonth', 'fromYear', 'toMonth', 'toYear'];

    const handleChange = (event, fileTypeId = fileTypeCriteria.fileTypeId) => {
        event.preventDefault();

        const fieldName = event.target.name;
        const value = event.target.value;

        const setCriteria = SETTER_BY_TYPE[fileTypeId] || setDataCriteria;
        const current = CRITERIA_BY_TYPE[fileTypeId] || dataCriteria;

        setCriteria({
            ...current,
            [fieldName]: value
        });

        if (AUTO_SEARCH_FIELDS.includes(fieldName)) {
            setCurrentPage(1);
            setSearchVersion(v => v + 1);
        }
    };

    //money-formatted input (mirrors Register.js checkAmount handling)
    const handleMoneyChange = (event, fileTypeId = fileTypeCriteria.fileTypeId) => {
        event.preventDefault();

        const fieldName = event.target.name;
        const value = event.target.value;

        const setCriteria = SETTER_BY_TYPE[fileTypeId] || setDataCriteria;
        const current = CRITERIA_BY_TYPE[fileTypeId] || dataCriteria;
        const oldValue = current[fieldName] || '';

        let positionIncrement = 0;

        let newValue = value.replace("$", "").replaceAll(",", "");

        if (newValue == ".") {
            newValue = "0.";
            positionIncrement = 1;
        }

        const validNumber = /^\d*\.?\d{0,2}$/;
        if (newValue.search(validNumber) == -1) {
            newValue = oldValue;
            positionIncrement = -1;
        } else if (newValue != "" && /\d/.test(newValue)) {
            const numericValue = parseFloat(newValue);
            const suffix = value.endsWith(".") ? "." : (value.endsWith(".0") ? ".0" : "");
            newValue = "$" + numericValue.toLocaleString("en-US") + suffix;
        }

        const oldCommaCount = (oldValue.match(/,/g) || []).length;
        const newCommaCount = (newValue.match(/,/g) || []).length;
        positionIncrement += (newCommaCount - oldCommaCount);

        const oldDollarCount = (oldValue.match(/\$/g) || []).length;
        const newDollarCount = (newValue.match(/\$/g) || []).length;
        positionIncrement += (newDollarCount - oldDollarCount);

        if (oldValue == "") {
            positionIncrement += 1;
        }

        const inputBox = event.target;
        const startPos = inputBox.selectionStart + positionIncrement;
        const endPos = inputBox.selectionEnd + positionIncrement;
        setTimeout(() => {
            inputBox.setSelectionRange(startPos, endPos);
        }, 10);

        setCriteria({
            ...current,
            [fieldName]: newValue
        });
    };

    //strip money formatting before sending to API ($1,234.56 -> 1234.56)
    const stripMoney = (v) => (v || '').toString().replace("$", "").replaceAll(",", "");

    //const changeFileType = async (nextValue) => {
    //    setDataStatus('loading');

    //    setFileTypeCriteria(prev => ({ ...prev, fileTypeId: nextValue }));
    //    setCurrentPage(1);

    //    const criteria = (nextValue === '2') ? jibDataCriteria : (nextValue === '4') ? ten99DataCriteria : dataCriteria;
    //    const currentCriteria = { ...criteria, skipCount: 0 };

    //    try {
    //        const response = await populateCheckStatementsInitial(currentCriteria, nextValue);
    //        if (!response.data || response.data.length === 0) {
    //            setRowCount(0);
    //            setCheckStatements([]);
    //            setDataStatus('nodata');
    //        } else {
    //            setRowCount(response.data[0]?.rowCount || 0);
    //            setCheckStatements(response.data);
    //            setDataStatus('ready');
    //        }
    //    } catch (ex) {
    //        setDataStatus('error');
    //        setDataErrors(ex.message);
    //    }
    //};//

    const handleTabSelect = (eventKey) => {
        if (!eventKey || eventKey === fileTypeCriteria.fileTypeId) return;
        setFileTypeCriteria({ fileTypeId: String(eventKey) });
        setCurrentPage(1);
    };

    //handle form submit
    const submitForm = async (e) => {
        e.preventDefault();
        setDataStatus('loading');
        setCurrentPage(1);

        const ft = fileTypeCriteria.fileTypeId;
        const setCriteria = SETTER_BY_TYPE[ft] || setDataCriteria;
        const nextCriteria = { ...getActiveCriteria(ft), skipCount: 0 };
        setCriteria(nextCriteria);

        try {
            const response = await populateCheckStatements({ skipCount: 0, fileTypeId: ft, criteria: nextCriteria });
            if (!response.data || response.data.length === 0) {
                setRowCount(0);
                setCheckStatements([]);
                setDataStatus('nodata');
            } else {
                setRowCount(response.data[0]?.rowCount || 0);
                setCheckStatements(response.data);
                setDataStatus('ready');
            }
        } catch (ex) {
            setDataStatus('error');
            setDataErrors(ex.message);
        }
    };

    const latestRequestRef = useRef(0);

    //handle page click
    const handlePageClick = async (page) => {
        console.log('Current Page:', page);
        setDataStatus('loading');
        setCurrentPage(page);

        const ft = fileTypeCriteria.fileTypeId;
        const take = activeCriteria.takeCount || 50;
        const skipCount = page === 1 ? 0 : (page - 1) * take;

        const setCriteria = SETTER_BY_TYPE[ft] || setDataCriteria;
        const nextCriteria = { ...getActiveCriteria(ft), skipCount }
        setCriteria(nextCriteria);

        const requestId = ++latestRequestRef.current;

        try {
            const response = await populateCheckStatements({ skipCount, fileTypeId: ft, criteria: nextCriteria });

            if (latestRequestRef.current !== requestId) {
                return;
            }

            if (!response.data || response.data.length === 0) {
                setRowCount(0);
                setCheckStatements([]);
                setDataStatus('nodata');
            } else {
                setRowCount(response.data[0]?.rowCount || 0);
                setCheckStatements(response.data);
                setDataStatus('ready');
            }
        } catch (ex) {
            if (latestRequestRef.current !== requestId) return;
            setDataStatus('error');
            setDataErrors(ex.message);
        }
    };


    const getActiveCriteria = (ft) =>
        ft === "2" ? jibDataCriteria : ft === "4" ? ten99DataCriteria : dataCriteria;

    const populateCheckStatements = async ({
        skipCount = 0,
        fileTypeId = fileTypeCriteria.fileTypeId,
        criteria = null
    } = {}) => {
        const crit = criteria ?? { ...getActiveCriteria(fileTypeId), skipCount };

        const qs = new URLSearchParams();
        qs.set("operatorId", String(crit.operatorId || 0));
        qs.set("skipCount", String(crit.skipCount || 0));
        qs.set("takeCount", String(crit.takeCount || 50));
        if (crit.ownerName) qs.set("ownerName", crit.ownerName);
        if (crit.membershipStatus) qs.set("membershipStatus", crit.membershipStatus);
        if (fileTypeId === "1") {
            if (crit.ownerNumber) qs.set("ownerNumber", crit.ownerNumber);
            if (crit.checkNumber) qs.set("checkNumber", crit.checkNumber);
            const ca = stripMoney(crit.checkAmount);
            if (ca) qs.set("checkAmount", ca);
        }
        if (fileTypeId === "2") {
            if (crit.ownerNumber) qs.set("ownerNumber", crit.ownerNumber);
            if (crit.invoiceNumber) qs.set("invoiceNumber", crit.invoiceNumber);
            const ia = stripMoney(crit.invoiceAmount);
            if (ia) qs.set("invoiceAmount", ia);
        }
        if (fileTypeId === "4") {
            if (crit.ownerNumber) qs.set("ownerNumber", crit.ownerNumber);
        }
        if (fileTypeId !== "4") {
            if (crit.fromMonth) qs.set("fromMonth", String(crit.fromMonth));
            if (crit.toMonth) qs.set("toMonth", String(crit.toMonth));
        }
        if (crit.fromYear) qs.set("fromYear", String(crit.fromYear));
        if (crit.toYear) qs.set("toYear", String(crit.toYear));
        if (typeof crit.statusId !== "undefined") qs.set("statusId", String(crit.statusId));

        qs.set("statementTypeId", String(fileTypeId));

        const apiUrl = "accounts/" + currentAccount.id + "/checkstatements?" + qs.toString();
        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json();
        console.log("Response - Status:", response.status, "Success:", response.ok, "Json:", JSON.stringify(json));
        return { success: response.ok, data: json };
    };

    const downloadCdex = async (exportType, checkId, index) => {

        const checkStatement = { ...checkStatements[index] };
        const senderId = checkStatement.operatorId;
        const cdexSenderCode = checkStatement.cdexSenderCode;
        console.log('CheckId: ' + checkId + ', SenderId: ' + senderId + ', Cdex Sender Code: ' + cdexSenderCode);
        if ((cdexSenderCode ?? '') == '') {
            setSelectedOperator(checkStatement);
            setModalShow(true);
        }
        else {
            //alert('downloading...');
            await downloadPdf(exportType, checkId, index);
        }
    }

    //update cdexsendercode
    const updateCdexSenderCode = async (operatorId, cdexSenderCode) => {
        console.log('Saving cdexsendercode...');
        //setDataStatus('loading');

        console.log('OperatorId: ' + operatorId + ', CdexSenderCode: ' + cdexSenderCode);

        var selectedCompany = { id: operatorId, cdexSenderCode: cdexSenderCode };

        await saveCdexSenderCode(selectedCompany)
            .then(response => {
                if (response.success) {
                    setCheckStatements(checkStatements.map((checkStatement, index) => {
                        if (checkStatement.operatorId == selectedCompany.id) {
                            return { ...checkStatement, cdexSenderCode: cdexSenderCode };
                        }
                        else {
                            return checkStatement;
                        }
                    }));
                    console.log('ready');
                    //setDataStatus('ready');
                    setModalShow(false);
                }
                else {
                    //TODO: figure out what to do here
                    console.log('nodata');
                    //setDataStatus('nodata')
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    };

    //save cdexsendercode
    const saveCdexSenderCode = async (selectedCompany) => {
        console.log('Saving cdexsendercode...');

        const apiUrl = 'accounts/' + currentAccount.id + '/updatesendingoperator/' + selectedCompany.id;
        const jsonBody = JSON.stringify(selectedCompany);
        //console.log(apiUrl);
        //console.log(jsonBody);

        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);

        return { success: response.ok };
    };

    //function isAdminOrTestUser(profile) {
    //    return !profile?.hasImpersonate
    //};

    function isAdminorTestUser(profile) {
        return !(
            profile?.hasImpersonate
        );
    }

    const downloadPdf = async (exportType, checkId, index) => {
        try {
            setDataStatus('loading');

            var selectedStatement = checkStatements.filter(function(statement) {
                return statement.checkId === parseInt(checkId);
            })[0];

            let fileName = selectedStatement.fileNamePrefix + '.';
            if (exportType === 'Cdex') {
                fileName = selectedStatement.cdexFileName;
            }

            let flaggenerated = isAdminorTestUser(accountProfile);

            let apiUrl = 'a_export/';
            switch (exportType) {
                case 'Pdf':
                    apiUrl = 'a_report/pdfreport';
                    fileName = fileName + 'pdf';
                    break;
                case 'Excel':
                    apiUrl = apiUrl + 'excel';
                    fileName = fileName + 'xlsx';
                    break;
                case 'Jib':
                    apiUrl = apiUrl + 'jib';
                    fileName = fileName + 'xlsx';
                    break;
                case 'Cdex':
                    apiUrl = apiUrl + 'cdex';
                    //fileName = fileName + 'dat';
                    break;
                default:
                    break;
            }

            apiUrl = apiUrl + '?checkid=' + checkId + '&flaggenerated=' + flaggenerated + '&statementTypeId=' + fileTypeCriteria.fileTypeId;
            //console.log(apiUrl);

            await getDocument(checkId, apiUrl).then(response => {
                response.data.blob().then(blob => {
                    // Creating new object of PDF file
                    const fileURL = window.URL.createObjectURL(blob);
                    // Setting various property values
                    let alink = document.createElement('a');
                    alink.href = fileURL;
                    alink.download = fileName;
                    alink.click();

                    //https://stackoverflow.com/questions/29537299/how-can-i-update-state-item1-in-state-using-setstate
                    let checks = [...checkStatements];
                    let check = { ...checkStatements[index] };
                    check.ownerStatus = true;
                    checks[index] = check;
                    setCheckStatements(checks);

                    setDataStatus('ready');
                })
            });
        } catch (ex) {
            console.log(ex.message);
            setDataStatus('error');
            setDataErrors(ex.message);
        }
    };

    //getDocument
    const getDocument = async (checkId, apiUrl) => {
        //console.log('Getting User Profile...');

        console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Data: ' + response);

        return { success: response.ok, data: response };
    }

    //function getTen99VersionName(version) {
    //    if (version) {
    //        return version === 'O' ? 'Original' : 'Revised';
    //    } else {
    //        return "";
    //    }
    //}

    //render page loading
    //note: spinner overlay will eventually be at the page level (I think)
    const showPageLoading = () => {
        return (
            <div>
                <Spinner
                    animation="border"
                    style={{ width: '3rem', height: '3rem', marginBottom: '1rem', color: COLORS.gold }}
                />
            </div>
        );
    }

    //render page loading
    const showDataLoading = () => {
        return (
            <div
                style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}
            >
                <Spinner
                    animation="border"
                    role="status"
                    style={{
                        width: '5rem',
                        height: '5rem',
                        borderWidth: '0.5rem',
                        color: COLORS.gold
                    }}
                />
                <div style={{ marginTop: '12px', color: '#6c757d', fontSize: '0.9rem' }}>
                    Loading...
                </div>
            </div>
        );
    };

    //render page error
    const showPageError = () => {
        return (
            <div>
                Oops, there was a page load error: {pageErrors}
            </div>
        );
    }

    //render data error
    const showDataError = () => {
        return (
            <Row>
                Oops, there was a data load error: {dataErrors}
            </Row>
        );
    }

    ////render loading
    //const showLoading_BAK = () => {
    //    return (
    //        <div>
    //            <img src={spinnerIcon} alt="loading..." />
    //        </div>
    //    );
    //}

    //render table container
    const showTableContainer = () => {
        if (fileTypeCriteria.fileTypeId === "0") {
            return (
                <div>Select file type above...</div>
            );
        } else {
            return (
                <Card ref={cardRef} className="mb-4">
                    <Card.Header style={{ ...DK.header }}>
                        {showInputCriteria()}
                    </Card.Header>
                    <Card.Body ref={cardBodyRef} style={{ height: tableHeight.toString() + 'px', overflow: "auto", paddingTop: 0 }}>
                        {(() => {
                            switch (dataStatus) {
                                case 'loading':
                                    return showDataLoading()
                                case 'ready':
                                    return showData()
                                case 'error':
                                    return showDataError()
                                default:
                                    //return <p>No Data Loaded.</p>
                                    return <p></p>
                            }
                        })()}
                    </Card.Body>
                    <Card.Footer style={{ ...DK.footer }}>
                        <Container fluid style={{ height: '40px' }} >
                            {(() => {
                                if (dataStatus == 'ready') {
                                    return <Row>
                                        <Col className="d-flex justify-content-end">
                                            <PaginationComponent
                                                itemsCount={rowCount}
                                                itemsPerPage={activeCriteria.takeCount}
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
                                                pageClickHandler={handlePageClick}
                                                alwaysShown={true}
                                                itemStyle={{ ...paginationStyle }}
                                                activeItemStyle={{ ...activePaginationStyle }}
                                                itemEvents={{
                                                    onFocus: e => Object.assign(e.target.style, goldInputFocus),
                                                    onBlur: e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                }
                            })()}
                        </Container>
                    </Card.Footer>
                </Card>
            );
        }
    }

    //render input criteria
    const showInputCriteria = () => {
        const headerLabel = { ...formLabel, fontSize: '0.8rem' };

        return (
            <Container fluid>
                <Form onSubmit={submitForm}>
                    <Row className="g-2 align-items-end">
                        <Col xs={6} md={2}>
                            <Form.Group as={Col} className="mb-1" controlId="formOperator" style={{ marginRight: 20 }}>
                                <Form.Label
                                    style={headerLabel}
                                >
                                    Operated Company
                                </Form.Label>
                                <Form.Select
                                    name="operatorId"
                                    size="sm"
                                    aria-label="Operator"
                                    onChange={handleChange}
                                    style={{ ...inputSm }}
                                    value={activeCriteria.operatorId}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                >
                                    {operators.map((operator, i) => (
                                        <option key={i} value={operator.id}>{operator.companyName}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {/*<Col xs="auto">*/}
                        {/*    <Form.Group as={Col} className="mb-1" controlId="formOwner">*/}
                        {/*        <Form.Label>Non-Operated Company</Form.Label>*/}
                        {/*        <Form.Select name="ownerId" size="sm" aria-label="Owner" onChange={handleChange} >*/}
                        {/*            {owners.map((owner, i) => (*/}
                        {/*                <option key={i} value={owner.id}>{owner.companyName}</option>*/}
                        {/*            ))}*/}
                        {/*        </Form.Select>*/}
                        {/*    </Form.Group>*/}
                        {/*</Col>*/}
                        <Col xs="auto">
                            <Form.Group className="mb-1" controlId="ownerName" style={{ marginRight: 20 }}>
                                <Form.Label
                                    style={headerLabel}
                                >
                                    Owner Name
                                </Form.Label>
                                <Form.Control
                                    name="ownerName"
                                    size="sm"
                                    aria-label="Company Code"
                                    value={activeCriteria.ownerName}
                                    style={inputSm}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        {fileTypeCriteria.fileTypeId === '1' && (
                            <>
                                <Col xs="auto">
                                    <Form.Group className="mb-1" controlId="ownerNumber" style={{ marginRight: 10 }}>
                                        <Form.Label style={headerLabel}>Owner Number</Form.Label>
                                        <Form.Control
                                            name="ownerNumber"
                                            size="sm"
                                            aria-label="Owner Number"
                                            value={activeCriteria.ownerNumber || ''}
                                            style={{ ...inputSm, width: 120 }}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs="auto">
                                    <Form.Group className="mb-1" controlId="checkNumber" style={{ marginRight: 10 }}>
                                        <Form.Label style={headerLabel}>Check Number</Form.Label>
                                        <Form.Control
                                            name="checkNumber"
                                            size="sm"
                                            aria-label="Check Number"
                                            value={activeCriteria.checkNumber || ''}
                                            style={{ ...inputSm, width: 120 }}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs="auto">
                                    <Form.Group className="mb-1" controlId="checkAmount" style={{ marginRight: 20 }}>
                                        <Form.Label style={headerLabel}>Check Amount</Form.Label>
                                        <Form.Control
                                            name="checkAmount"
                                            size="sm"
                                            aria-label="Check Amount"
                                            value={activeCriteria.checkAmount || ''}
                                            style={{ ...inputSm, width: 120 }}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                            onChange={handleMoneyChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </>
                        )}
                        {fileTypeCriteria.fileTypeId === '2' && (
                            <>
                                <Col xs="auto">
                                    <Form.Group className="mb-1" controlId="ownerNumber" style={{ marginRight: 10 }}>
                                        <Form.Label style={headerLabel}>Owner Number</Form.Label>
                                        <Form.Control
                                            name="ownerNumber"
                                            size="sm"
                                            aria-label="Owner Number"
                                            value={activeCriteria.ownerNumber || ''}
                                            style={{ ...inputSm, width: 120 }}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs="auto">
                                    <Form.Group className="mb-1" controlId="invoiceNumber" style={{ marginRight: 10 }}>
                                        <Form.Label style={headerLabel}>Invoice Number</Form.Label>
                                        <Form.Control
                                            name="invoiceNumber"
                                            size="sm"
                                            aria-label="Invoice Number"
                                            value={activeCriteria.invoiceNumber || ''}
                                            style={{ ...inputSm, width: 120 }}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs="auto">
                                    <Form.Group className="mb-1" controlId="invoiceAmount" style={{ marginRight: 20 }}>
                                        <Form.Label style={headerLabel}>Invoice Amount</Form.Label>
                                        <Form.Control
                                            name="invoiceAmount"
                                            size="sm"
                                            aria-label="Invoice Amount"
                                            value={activeCriteria.invoiceAmount || ''}
                                            style={{ ...inputSm, width: 120 }}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                            onChange={handleMoneyChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </>
                        )}
                        {fileTypeCriteria.fileTypeId === '4' && (
                            <Col xs="auto">
                                <Form.Group className="mb-1" controlId="ownerNumber" style={{ marginRight: 20 }}>
                                    <Form.Label style={headerLabel}>Owner Number</Form.Label>
                                    <Form.Control
                                        name="ownerNumber"
                                        size="sm"
                                        aria-label="Owner Number"
                                        value={activeCriteria.ownerNumber || ''}
                                        style={{ ...inputSm, width: 140 }}
                                        onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                        onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                        )}
                        {(() => {
                            if (fileTypeCriteria.fileTypeId !== '4') {
                                return <Col xs="auto">
                                    <Form.Group className="mb-1" controlId="fromMonth">
                                        <Form.Label
                                            style={headerLabel}
                                        >
                                            From
                                        </Form.Label>
                                        <Form.Select
                                            name="fromMonth"
                                            size="sm"
                                            value={activeCriteria.fromMonth}
                                            aria-label="FromMonth"
                                            onChange={handleChange}
                                            style={inputSm}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                        >
                                            {months.map((month, i) => (
                                                <option key={i} value={i + 1}>{month}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            }
                        })()}
                        <Col xs="auto">
                            <Form.Group className="mb-1" controlId="fromYear">
                                {fileTypeCriteria.fileTypeId === '4' ? (
                                    <Form.Label
                                        style={headerLabel}
                                    >
                                        From
                                    </Form.Label>
                                ) : (
                                    <Form.Label style={headerLabel}>&nbsp;</Form.Label>
                                )}
                                <Form.Select
                                    name="fromYear"
                                    size="sm"
                                    value={activeCriteria.fromYear}
                                    aria-label="FromYear"
                                    onChange={handleChange}
                                    style={inputSm}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                >
                                    {years.map((year, i) => (
                                        <option key={i} value={year}>{year}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {(() => {
                            if (fileTypeCriteria.fileTypeId !== '4') {
                                return <Col xs="auto">
                                    <Form.Group className="mb-1" controlId="toMonth">
                                        <Form.Label
                                            style={headerLabel}
                                        >
                                            To
                                        </Form.Label>
                                        <Form.Select
                                            name="toMonth"
                                            size="sm"
                                            value={activeCriteria.toMonth}
                                            aria-label="ToMonth"
                                            onChange={handleChange}
                                            style={inputSm}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                        >
                                            {months.map((month, i) => (
                                                <option key={i} value={i + 1}>{month}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            }
                        })()}
                        <Col xs="auto">
                            <Form.Group className="mb-1" controlId="toYear" style={{ marginRight: 20 }}>
                                {fileTypeCriteria.fileTypeId === '4' ? (
                                    <Form.Label
                                        style={headerLabel}
                                    >
                                        To
                                    </Form.Label>
                                ) : (
                                    <Form.Label style={headerLabel}>&nbsp;</Form.Label>
                                )}
                                <Form.Select
                                    name="toYear"
                                    size="sm"
                                    value={activeCriteria.toYear}
                                    aria-label="ToYear"
                                    onChange={handleChange}
                                    style={{ ...inputSm }}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                >
                                    {years.map((year, i) => (
                                        <option key={i} value={year}>{year}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group as={Col} className="mb-1" controlId="formStatus">
                                <Form.Label
                                    style={headerLabel}
                                >
                                    Status
                                </Form.Label>
                                <Form.Select
                                    name="statusId"
                                    size="sm"
                                    aria-label="Status"
                                    onChange={handleChange}
                                    style={inputSm}
                                    value={activeCriteria.statusId}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                >
                                    {statusItems.map((status, i) => (
                                        <option key={i} value={i}>{status}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group as={Col} className="mb-1" controlId="buttonSubmit">
                                <Form.Label as={Row} style={headerLabel}><br /></Form.Label>
                                {dataStatus === "loading" ? (
                                    <Button
                                        style={{ ...btnGold, marginRight: 3 }}
                                        size="sm"
                                        disabled
                                    >
                                        <Spinner
                                            as="span"
                                            animation="grow"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    </Button>
                                ) : (
                                    <Button
                                        style={
                                            hoveredBtn && hoveredBtn.type === "search"
                                                ? { ...btnGold, ...btnGoldHover, marginRight: 3, transition: "all .15s ease" }
                                                : { ...btnGold, marginRight: 3 }
                                        }
                                        onMouseEnter={() => setHoveredBtn({ type: "search" })}
                                        onMouseLeave={() => setHoveredBtn(null)}
                                        type='submit'
                                        size="sm"
                                        disabled={pageStatus !== 'ready'}
                                    //onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    //onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                    >
                                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                                    </Button>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Container>
        );
    }

    //operator name, linked to Hilcorp owner relations for Hilcorp rows
    const showOperatorName = checkStatement => {
        if (!hasOwnerRelations(checkStatement))
            return checkStatement.operatorName;

        return (
            <a
                href="https://www.hilcorp.com/owner-relations/"
                target="_blank"
                rel="noopener noreferrer"
                title="Hilcorp Owner Relations"
                style={{ color: COLORS.blue, ...removeUnderline }}
                onMouseEnter={e => Object.assign(e.currentTarget.style, addUnderline)}
                onMouseLeave={e => Object.assign(e.currentTarget.style, removeUnderline)}
            >
                {checkStatement.operatorName}
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ marginLeft: '6px', fontSize: '0.75em' }} />
            </a>
        );
    };

    //render datafiles
    const showData = () => {
        const operatorTitle = checkStatements.some(hasOwnerRelations) ? <>Operator /<br />Owner Relations</> : 'Operator Name';
        const btnGoldSm = { ...btnGold, width: "100px", fontSize: ".75rem" };

        if (fileTypeCriteria.fileTypeId === "1") {  //**************************REVENUE**************************
            return (
                <Container fluid style={{ padding: 0 }}>
                    <Row>
                        <div
                            style={{
                                maxoverflow: 'auto'
                            }}
                        >
                            <table className="table table-striped" aria-labelledby="tabelLabel" style={{ fontSize: '.85rem' }} >
                                <thead>
                                    <tr>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            CDEX<br />Sender Code
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            {operatorTitle}
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Op Owner #
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Owner Name
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Check Number
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Check Date
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Check Amount
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Status
                                        </th>
                                        <th colSpan={3} style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900, textAlign: "center" }}>
                                            {/*{(() => {*/}
                                            {/*    if (accountProfile.hasImpersonate) {*/}
                                            {/*        return <p style={{ marginBottom: '0px', color: 'red', fontWeight: '800', fontSize: '1.1rem' }}>All formats are FREE!!</p>*/}
                                            {/*    }*/}
                                            {/*})()} */}
                                            {/*<p style={{ marginBottom: '0px', color: 'red', fontWeight: '800', fontSize: '1.1rem' }}>All formats are FREE!!</p>*/}
                                            <p style={{ marginBottom: '0px' }}>Check Statements</p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {checkStatements.map((checkStatement, index) => (
                                        <tr
                                            key={checkStatement.checkId}
                                            style={{
                                                fontSize: ".8rem",
                                                fontWeight: "500",
                                            }}
                                            onMouseEnter={e => Object.assign(e.currentTarget.style, tableRowHover)}
                                            onMouseLeave={e => Object.assign(e.currentTarget.style, tableRowUnHover)}
                                        >
                                            <td>{checkStatement.cdexSenderCode}</td>
                                            <td>{showOperatorName(checkStatement)}</td>
                                            <td>{checkStatement.ownerCompanyCode}</td>
                                            <td>{checkStatement.ownerName}</td>
                                            <td>{checkStatement.checkNumber}</td>
                                            <td>{checkStatement.checkDateString}</td>
                                            <td>{checkStatement.checkAmountString}</td>
                                            <td>{(checkStatement.ownerStatus === true ? "Downloaded" : "Released")}</td>
                                            <td>
                                                <Button
                                                    id={checkStatement.checkId}
                                                    variant="primary"
                                                    size="sm"
                                                    style={{
                                                        ...btnGoldSm,
                                                        marginLeft: "20px"
                                                    }}
                                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                    value={checkStatement.checkId}
                                                    onClick={(e) => downloadPdf('Pdf', e.currentTarget.value, index)}
                                                >
                                                    Create PDF
                                                </Button>
                                            </td>
                                            <td>
                                                {(() => {
                                                    if (canCreateRevenueFiles) {
                                                        return <HoverPopoverTrigger popoverId={`${checkStatement.checkId}-excel`} openPopoverId={openPopoverId} setOpenPopoverId={setOpenPopoverId} overlay={popoverNoFee} showDelay={500}>
                                                            <Button
                                                                id={checkStatement.checkId}
                                                                variant="primary"
                                                                size="sm"
                                                                style={{
                                                                    ...btnGoldSm,
                                                                }}
                                                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                                value={checkStatement.checkId}

                                                                onClick={(e) => downloadPdf('Excel', e.currentTarget.value, index)}
                                                            >
                                                                Create Excel
                                                            </Button>
                                                        </HoverPopoverTrigger>
                                                    }

                                                    return <HoverPopoverTrigger popoverId={`${checkStatement.checkId}-excel`} openPopoverId={openPopoverId} setOpenPopoverId={setOpenPopoverId} overlay={popoverRevenueMembership} showDelay={500}>
                                                        <Button
                                                            id={checkStatement.checkId}
                                                            size="sm"
                                                            style={{
                                                                ...btnGoldSm,
                                                            }}
                                                            onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                            onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                            value={checkStatement.checkId}
                                                            onClick={hasImpersonate ? (e) => downloadPdf('Excel', e.currentTarget.value, index) : null}
                                                        >
                                                            Create Excel
                                                        </Button>
                                                    </HoverPopoverTrigger>
                                                })()}
                                            </td>
                                            <td>
                                                {(() => {
                                                    if (canCreateRevenueFiles) {
                                                        return <HoverPopoverTrigger popoverId={`${checkStatement.checkId}-cdex`} openPopoverId={openPopoverId} setOpenPopoverId={setOpenPopoverId} overlay={popoverNoFee} showDelay={500}>
                                                            <Button
                                                                id={checkStatement.checkId}
                                                                variant="primary"
                                                                size="sm"
                                                                style={{
                                                                    ...btnGoldSm,
                                                                }}
                                                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                                value={checkStatement.checkId}

                                                                onClick={(e) => downloadCdex('Cdex', e.currentTarget.value, index)}
                                                            >
                                                                Create CDEX
                                                            </Button>
                                                        </HoverPopoverTrigger>
                                                    }

                                                    return <HoverPopoverTrigger popoverId={`${checkStatement.checkId}-cdex`} openPopoverId={openPopoverId} setOpenPopoverId={setOpenPopoverId} overlay={popoverRevenueMembership}>
                                                        <Button
                                                            id={checkStatement.checkId}
                                                            size="sm"
                                                            style={{
                                                                ...btnGoldSm,
                                                            }}
                                                            onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                            onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                            value={checkStatement.checkId}
                                                            onClick={hasImpersonate ? (e) => downloadCdex('Cdex', e.currentTarget.value, index) : null}
                                                        >
                                                            Create CDEX
                                                        </Button>
                                                    </HoverPopoverTrigger>
                                                })()}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Row>
                </Container>
            );
        } else if (fileTypeCriteria.fileTypeId === "2") {  //**************************JIB**************************
            return (
                <Container fluid style={{ padding: 0 }}>
                    <Row>
                        <div
                            style={{
                                maxoverflow: 'auto'
                            }}
                        >
                            <table className="table table-striped" aria-labelledby="tabelLabel" style={{ fontSize: '.85rem' }} >
                                <thead>
                                    <tr>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            {operatorTitle}
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Op Owner #
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Owner Name
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Invoice Number
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Invoice Date
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Invoice Amount
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Status
                                        </th>
                                        <th colSpan={3} style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900, textAlign: "center" }}>
                                            {/*{(() => {*/}
                                            {/*    if (accountProfile.hasImpersonate) {*/}
                                            {/*        return <p style={{ marginBottom: '0px', color: 'red', fontWeight: '800', fontSize: '1.1rem' }}>All formats are FREE!!</p>*/}
                                            {/*    }*/}
                                            {/*})()} */}
                                            {/*<p style={{ marginBottom: '0px', color: 'red', fontWeight: '800', fontSize: '1.1rem' }}>All formats are FREE!!</p>*/}
                                            <p style={{ marginBottom: '0px' }}>JIB Statements</p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {checkStatements.map((checkStatement, index) => (
                                        <tr
                                            key={checkStatement.checkId}
                                            style={{
                                                fontSize: ".8rem",
                                                fontWeight: "500",
                                            }}
                                            onMouseEnter={e => Object.assign(e.currentTarget.style, tableRowHover)}
                                            onMouseLeave={e => Object.assign(e.currentTarget.style, tableRowUnHover)}
                                        >
                                            <td>{showOperatorName(checkStatement)}</td>
                                            <td>{checkStatement.ownerCompanyCode}</td>
                                            <td>{checkStatement.ownerName}</td>
                                            <td>{checkStatement.checkNumber}</td>
                                            <td>{checkStatement.checkDateString}</td>
                                            <td>{checkStatement.checkAmountString}</td>
                                            <td>{(checkStatement.ownerStatus === true ? "Downloaded" : "Released")}</td>
                                            <td>
                                                <Button
                                                    id={checkStatement.checkId}
                                                    variant="primary"
                                                    size="sm"
                                                    style={{
                                                        ...btnGoldSm,
                                                        marginLeft: "20px"
                                                    }}
                                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                    value={checkStatement.checkId}
                                                    onClick={(e) => downloadPdf('Pdf', e.currentTarget.value, index)}
                                                >
                                                    Create PDF
                                                </Button>
                                            </td>
                                            <td>
                                                {(() => {
                                                    if (canCreateJibFiles) {
                                                        return <HoverPopoverTrigger popoverId={`${checkStatement.checkId}-jib`} openPopoverId={openPopoverId} setOpenPopoverId={setOpenPopoverId} overlay={popoverNoFee} showDelay={500}>
                                                            <Button
                                                                id={checkStatement.checkId}
                                                                variant="primary"
                                                                size="sm"
                                                                style={{
                                                                    ...btnGoldSm,
                                                                }}
                                                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                                value={checkStatement.checkId}

                                                                onClick={(e) => downloadPdf('Jib', e.currentTarget.value, index)}
                                                            >
                                                                Create Excel
                                                            </Button>
                                                        </HoverPopoverTrigger>
                                                    }

                                                    return <HoverPopoverTrigger popoverId={`${checkStatement.checkId}-jib`} openPopoverId={openPopoverId} setOpenPopoverId={setOpenPopoverId} overlay={popoverJibMembership} showDelay={500}>
                                                        <Button
                                                            id={checkStatement.checkId}
                                                            size="sm"
                                                            style={{
                                                                ...btnGoldSm,
                                                            }}
                                                            onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                            onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                            value={checkStatement.checkId}
                                                            onClick={hasImpersonate ? (e) => downloadPdf('Jib', e.currentTarget.value, index) : null}
                                                        >
                                                            Create Excel
                                                        </Button>
                                                    </HoverPopoverTrigger>
                                                })()}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Row>
                </Container>
            );
        } else if (fileTypeCriteria.fileTypeId === "4") {  //**************************1099**************************
            return (
                <Container fluid style={{ padding: 0 }}>
                    <Row>
                        <div
                            style={{
                                maxoverflow: 'auto'
                            }}
                        >
                            <table className="table table-striped" aria-labelledby="tabelLabel" style={{ fontSize: '.85rem' }} >
                                <thead>
                                    <tr>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            {operatorTitle}
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Op Owner #
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Owner Name
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Tax Year
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Version
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 13, fontWeight: 900 }}>
                                            Status
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {checkStatements.map((checkStatement, index) => (
                                        <tr
                                            key={checkStatement.checkId}
                                            style={{
                                                fontSize: ".8rem",
                                                fontWeight: "500",
                                            }}
                                            onMouseEnter={e => Object.assign(e.currentTarget.style, tableRowHover)}
                                            onMouseLeave={e => Object.assign(e.currentTarget.style, tableRowUnHover)}
                                        >
                                            <td>{showOperatorName(checkStatement)}</td>
                                            <td>{checkStatement.ownerCompanyCode}</td>
                                            <td>{checkStatement.ownerName}</td>
                                            <td>{checkStatement.ten99TaxYear}</td>
                                            <td>{checkStatement.ten99Version}</td>
                                            <td>{(checkStatement.ownerStatus === true ? "Downloaded" : "Released")}</td>
                                            <td>
                                                <Button
                                                    id={checkStatement.checkId}
                                                    variant="primary"
                                                    size="sm"
                                                    style={{
                                                        ...btnGoldSm,
                                                        marginLeft: "20px"
                                                    }}
                                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                    value={checkStatement.checkId}
                                                    onClick={(e) => downloadPdf('Pdf', e.currentTarget.value, index)}
                                                >
                                                    Create PDF
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Row>
                </Container>
            );
        }
    }

    //render component
    return (
        <>
            <p style={{ fontSize: '1.75rem', fontWeight: '700', color: '#333333', marginTop: '8px', marginBottom: '4px', textAlign: 'center' }}>Non-Operated Statements</p>
            <div className="mb-3">
                <Nav
                    variant="tabs"
                    activeKey={fileTypeCriteria.fileTypeId}
                    onSelect={handleTabSelect}
                    style={{
                        borderBottom: `1px solid ${COLORS.gold}`
                    }}
                >
                    <Nav.Item>
                        <Nav.Link
                            eventKey="1"
                            style={{
                                width: '150px',
                                textAlign: 'center',
                                fontWeight: fileTypeCriteria.fileTypeId === '1' ? '600' : 'normal',
                                fontSize: fileTypeCriteria.fileTypeId === '1' ? '1.1rem' : '0.9rem',
                                letterSpacing: fileTypeCriteria.fileTypeId === '1' ? '0.4px' : '0',
                                borderColor: fileTypeCriteria.fileTypeId === '1'
                                    ? `${COLORS.gold} ${COLORS.gold} transparent`
                                    : undefined,
                                color: fileTypeCriteria.fileTypeId === '1' ? '#333333' : '#6c757d',
                                transform: fileTypeCriteria.fileTypeId === '1' ? 'translateY(0)' : 'translateY(' + 4 + 'px)'
                            }}
                        >
                            Revenue
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            eventKey="2"
                            disabled={!isJibEnabled}
                            style={{
                                width: '150px',
                                textAlign: 'center',
                                fontWeight: fileTypeCriteria.fileTypeId === '2' ? '600' : 'normal',
                                fontSize: fileTypeCriteria.fileTypeId === '2' ? '1.1rem' : '0.9rem',
                                letterSpacing: fileTypeCriteria.fileTypeId === '2' ? '0.4px' : '0',
                                borderColor: fileTypeCriteria.fileTypeId === '2'
                                    ? `${COLORS.gold} ${COLORS.gold} transparent`
                                    : undefined,
                                color: fileTypeCriteria.fileTypeId === '2' ? '#333333' : '#6c757d',
                                transform: fileTypeCriteria.fileTypeId === '2' ? 'translateY(0)' : 'translateY(' + 4 + 'px)'
                            }}
                        >
                            JIB
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            eventKey="4"
                            disabled={!is1099Enabled}
                            style={{
                                width: '150px',
                                textAlign: 'center',
                                fontWeight: fileTypeCriteria.fileTypeId === '4' ? '600' : 'normal',
                                fontSize: fileTypeCriteria.fileTypeId === '4' ? '1.1rem' : '0.9rem',
                                letterSpacing: fileTypeCriteria.fileTypeId === '4' ? '0.4px' : '0',
                                borderColor: fileTypeCriteria.fileTypeId === '4'
                                    ? `${COLORS.gold} ${COLORS.gold} transparent`
                                    : undefined,
                                color: fileTypeCriteria.fileTypeId === '4' ? '#333333' : '#6c757d',
                                transform: fileTypeCriteria.fileTypeId === '4' ? 'translateY(0)' : 'translateY(' + 4 + 'px)'
                            }}
                        >
                            1099
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </div>
            {(() => {
                switch (pageStatus) {
                    case 'loading':
                        return showPageLoading()
                    case 'ready':
                        if (displayResultGrid === true) {
                            return showTableContainer()
                        } else {
                            return <p></p>
                        }
                    case 'error':
                        return showPageError()
                    default:
                        return <p>No Page Loaded.</p>
                }
            })()}

            <CdexSenderCodeModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                onYes={() => navigate('/sendingoperators')}
                selectedOperator={selectedOperator}
                setSelectedOperator={setSelectedOperator}
                updateCdexSenderCode={updateCdexSenderCode}
            />

            <MembershipModal
                show={memberModalShow}
                onHide={() => setMemberModalShow(false)}
                onMemberButtonClick={() => navigate('/membership-plans')}
                messageLines={[
                    'Unlimited Excel & CDEX Conversion for all your operators data.',
                    'Upgrade to Blackgold - Revenue or Oil Baron to access!'
                ]}
            />
        </>
    );
}

export default CheckFiles;